import Context from "../models/Context";

const context = new Context();

export const keys = {
  asset: context.edcNamespace + "Asset",
  dataAddress: context.edcNamespace + "dataAddress",
  dataAddressType: context.edcNamespace + "DataAddress",
  properties: context.edcNamespace + "properties",
  publicItem: context.edcNamespace + "public",
  externalItem: context.edcNamespace + "external",
  publicDownloadUrl: context.edcNamespace + "downloadUrl",
  title: context.dctNamespace + "title",
  annotationType: context.msNamespace + "annotationType",
  anonymizationDetails: context.msNamespace + "anonymizationDetails",
  anonymized: context.msNamespace + "anonymized",
  corpusSubclass: context.msNamespace + "corpusSubclass",
  cost: context.msNamespace + "cost",
  domain: context.msNamespace + "domain",
  iprHolder: context.msNamespace + "iprHolder",
  isDocumentedBy: context.msNamespace + "isDocumentedBy",
  mslanguage: context.msNamespace + "language",
  msLanguage: context.msNamespace + "Language",
  citationText: context.msNamespace + "citationText",
  languageCode: context.msNamespace + "languageCode",
  hasOriginalSource: context.msNamespace + "hasOriginalSource",
  languageVarietyName: context.msNamespace + "languageVarietyName",
  region: context.msNamespace + "region",
  script: context.msNamespace + "script",
  variant: context.msNamespace + "variant",
  dcLanguage: context.dctNamespace + "language",
  lingualityType: context.msNamespace + "lingualityType",
  lcrSubclass: context.msNamespace + "lcrSubclass",
  linguisticInformation: context.msNamespace + "linguisticInformation",
  lrType: context.msNamespace + "lrType",
  msmediaType: context.msNamespace + "mediaType",
  msfunction: context.msNamespace + "function",
  softwareDistributionForm: context.msNamespace + "softwareDistributionForm",
  softwareDistribution: context.msNamespace + "SoftwareDistribution",
  softwareDistributionProperty: context.msNamespace + "softwareDistribution",
  executionLocation: context.msNamespace + "executionLocation",
  multilingualityType: context.msNamespace + "multilingualityType",
  personalDataDetails: context.msNamespace + "personalDataDetails",
  personalDataIncluded: context.msNamespace + "personalDataIncluded",
  sensitiveDataDetails: context.msNamespace + "sensitiveDataDetails",
  sensitiveDataIncluded: context.msNamespace + "sensitiveDataIncluded",
  originalSourceDescription: context.msNamespace + "originalSourceDescription",
  pivotLanguage: context.msNamespace + "pivotLanguage",
  sourceLanguage: context.msNamespace + "sourceLanguage",
  targetLanguage: context.msNamespace + "targetLanguage",
  metalanguage: context.msNamespace + "metalanguage",
  languageTag: context.msNamespace + "languageTag",
  distribution: context.dcatNamespace + "distribution",
  distributionType: context.dcatNamespace + "Distribution",
  keyword: context.dcatNamespace + "keyword",
  version: context.dcatNamespace + "version",
  alternative: context.dctNamespace + "alternative",
  conformsTo: context.dctNamespace + "conformsTo",
  description: context.dctNamespace + "description",
  dctIdentifier: context.dctNamespace + "identifier",
  admsIdentifier: context.admsNamespace + "identifier",
  admsIdentifierCapital: context.admsNamespace + "Identifier",
  license: context.dctNamespace + "license",
  publisher: context.dctNamespace + "publisher",
  temporal: context.dctNamespace + "temporal",
  periodOfTime: context.dctNamespace + "PeriodOfTime",
  spatial: context.dctNamespace + "spatial",
  name: context.foafNamespace + "name",
  accessURL: context.dcatNamespace + "accessURL",
  downloadURL: context.dcatNamespace + "downloadURL",
  dcatmediaType: context.dcatldsNamespace + "mediaType",
  byteSize: context.dcatNamespace + "byteSize",
  packageFormat: context.dcatNamespace + "packageFormat",
  accessLocation: context.msNamespace + "accessLocation",
  downloadLocation: context.msNamespace + "downloadLocation",
  size: context.msNamespace + "size",
  amount: context.msNamespace + "amount",
  sizeUnit: context.msNamespace + "sizeUnit",
  processingResourceType: context.msNamespace + "processingResourceType",
  processingResource: context.msNamespace + "ProcessingResource",
  processingResourceProperty: context.msNamespace + "processingResource",
  outputResource: context.msNamespace + "outputResource",
  inputContentResource: context.msNamespace + "inputContentResource",
  languageDependent: context.msNamespace + "languageDependent",
  endDate: context.dcatNamespace + "endDate",
  startDate: context.dcatNamespace + "startDate",
  currency: context.msNamespace + "currency",
  purlMediaType: context.dctNamespace + "MediaType",
  purlLicenseType: context.dctNamespace + "LicenseDocument",
  agentType: context.foafNamespace + "Agent",
  dateType: context.xsdNamespace + "date",
  documentType: context.foafNamespace + "Document",
  baseUrl: context.edcNamespace + "baseUrl",
  requiresAuth: context.edcNamespace + "requiresAuth",
  storageSolutionId: context.edcNamespace + "storageSolutionId",
  s3type: context.edcNamespace + "s3type",
  objectName: context.edcNamespace + "objectName",
  uriType: context.xsdNamespace + "anyURI",
  stringType: context.xsdNamespace + "string",
  unsignedLongType: context.xsdNamespace + "unsignedLong",
  edcType: context.edcNamespace + "type",
  edcName: context.edcNamespace + "name",
  edcPolicy: context.edcNamespace + "policy",
  hasPolicy: context.odrlNamespace + "hasPolicy",
  odrlObligation: context.odrlNamespace + "obligation",
  odrlPermission: context.odrlNamespace + "permission",
  odrlProhibition: context.odrlNamespace + "prohibition",
  odrlAction: context.odrlNamespace + "action",
  odrlConstraint: context.odrlNamespace + "constraint",
  odrlType: context.odrlNamespace + "type",
  leftOperand: context.odrlNamespace + "leftOperand",
  operator: context.odrlNamespace + "operator",
  rightOperand: context.odrlNamespace + "rightOperand",
  odrlAnd: context.odrlNamespace + "and",
  corpus: context.msNamespace + "corpus1",
  mLModel: context.msNamespace + "mlModel",
  lcr: context.msNamespace + "lexicalConceptualResource1",
  toolService: context.msNamespace + "toolService1",
  dctCreator: context.dctNamespace + "creator",
  notation: context.skosNamespace + "notation",
  schemaAgency: context.admsNamespace + "schemaAgency",
  person: context.foafNamespace + "Person",
  organization: context.foafNamespace + "Organization",
  dataProtectionPrincipleApplied: context.msNamespace + "dataProtectionPrincipleApplied",
  hasTechnicalOrganisationalMeasure: context.dpvNamespace + "hasTechnicalOrganisationalMeasure",
  variantOf: context.msNamespace + "variantOf",
  finetuneDataset: context.msNamespace + "finetuneDataset",
  evaluationDataset: context.msNamespace + "evaluationDataset",
  quantized: context.msNamespace + "quantized",
  quantizationProcess: context.msNamespace + "quantizationProcess",
  parameterPrecision: context.msNamespace + "parameterPrecision",
  modelType: context.msNamespace + "modelType",
  modelFunction: context.msNamespace + "modelFunction",
  evaluationResults: context.msNamespace + "evaluationResults",
  creationDetails: context.msNamespace + "creationDetails",
  contextLength: context.msNamespace + "contextLength",
  // it6Namespace
  trainedOn: context.it6Namespace + "trainedOn",
  limitations: context.it6Namespace + "limitations",
  measurementMethodology: context.it6Namespace + "measurementMethodology",
  environmentalImpactType: context.it6Namespace + "EnvironmentalImpact",
  environmentalImpact: context.it6Namespace + "EnvironmentalImpact",
  hasInferencingImpact: context.it6Namespace + "hasInferencingImpact",
  hasTrainingImpact: context.it6Namespace + "hasTrainingImpact",
  powerConsumption: context.it6Namespace + "powerConsumption",
  hasInputModality: context.it6Namespace + "hasInputModality",
  hasOutputModality: context.it6Namespace + "hasOutputModality",
  modalityType: context.it6Namespace + "Modality",
  modality: context.it6Namespace + "modality",
  bias: context.it6Namespace + "bias",
  intendedUse: context.it6Namespace + "intendedUse",
  releaseDate: context.it6Namespace + "releaseDate",
  designSpecifications: context.it6Namespace + "designSpecifications",
  trainingMethodologies: context.it6Namespace + "trainingMethodologies",
  trainingProcess: context.it6Namespace + "trainingProcess",
  hasBenchmark: context.it6Namespace + "hasBenchmark",
  hasBenchmarkType: context.it6Namespace + "Benchmark",
  // dcatlds
  format: context.dcatldsNamespace + "format",
  instructions: context.dcatldsNamespace + "instructions",
  finetuningMethodology: context.dcatldsNamespace + "finetuningMethodology",
  inputLanguage: context.dcatldsNamespace + "inputLanguage",
  accessLevel: context.dcatldsNamespace + "accessLevel",
  amountOfActiveParameters: context.dcatldsNamespace + "amountOfActiveParameters",
  distributionMethod: context.dcatldsNamespace + "distributionMethod",
  tokensPerParameter: context.dcatldsNamespace + "tokensPerParameter",
  ModelDistributionType: context.dcatldsNamespace + "ModelDistribution",
  modelDistribution: context.dcatldsNamespace + "modelDistribution",
  outputLanguage: context.dcatldsNamespace + "outputLanguage",
  modified: context.dctNamespace + "modified",
  requiresSoftware: context.msNamespace + "requiresSoftware",
  languageType: context.dcatldsNamespace + "languageType",
  generationType: context.dcatldsNamespace + "generationType",
  generationModel: context.dcatldsNamespace + "generationModel",
  seedDataset: context.dcatldsNamespace + "seedDataset",
  generationProcess: context.dcatldsNamespace + "generationProcess",
  evaluationType: context.dcatldsNamespace + "Evaluation",
  evaluation: context.dcatldsNamespace + "evaluation",
  metric: context.dcatldsNamespace +"metric",
  task: context.dcatldsNamespace + "task",
  evaluationOutput: context.dcatldsNamespace + "evaluationOutput",
};

export const negotiationKeys = {
  participantId: "participantId",
  service: "dcat:service",
  dataset: "dcat:dataset",
  policy: "odrl:hasPolicy",
  title: "dct:title",
  endpointUrl: "dcat:endpointUrl",
};
